import { render, staticRenderFns } from "./Popups.vue?vue&type=template&id=a1fbff22&"
import script from "./Popups.vue?vue&type=script&lang=ts&"
export * from "./Popups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports